import * as S from './styles'

interface CuriosityProps {
  img: string
  title: string
  text: string
}

const Curiosity = ({ img, title, text }: CuriosityProps) => {
  return (
    <S.CuriosityContainer img={img} className="flexbox v-centered h-centered">
      <div className="content">
        <div className="text">
          <h3>{title}</h3>
          <p>{text}</p>
        </div>
      </div>
    </S.CuriosityContainer>
  )
}

export default Curiosity
